import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { NavigationService } from 'src/app/services/navigation.service';
import { RoleType } from 'src/app/enum/role-type';
import { ExcelService } from 'src/app/services/excel.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ProductService } from 'src/app/services/product.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-product',
  templateUrl: './manage-product.component.html',
  styleUrls: ['./manage-product.component.scss']
})
export class ManageProductComponent implements OnInit {
  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "productCategory",
    "subCategoryName",
    "productame",
    "cost",
    "provider",
    "status",
    "action"
  ];


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  dataExcel: any = [];
  excelColumns: string[];
  filterValue: string = "";
  roleTypeEnum = RoleType;
  sessionDataString: any;
  constructor(
    private ProductService: ProductService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private excelService: ExcelService,
    private navigationService: NavigationService,




  ) { }

  ngOnInit(): void {
    this.getTableData("")
    // this.dataSource = new MatTableDataSource(this.data);

  }

  getTableData(data){
    if (data) {
      data = { productName: this.searchInput.nativeElement.value  }
    }
    this.ProductService.getProducts(data).subscribe((result:any) => {
      console.log(result)
      this.data = [];
      this.dataExcel = [];
      this.data = result;
      this.dataExcel = result;
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  clearFilter() {
    const inputElement = document.getElementById('filter-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.dataSource.filter = '';
    this.searchInput.nativeElement.value = "";
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.sort.active = '';
    this.dataSource.sort.direction = '';
    this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
    this.getTableData('');
  }


  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        "Product Name",
        "Product Code",
        "Provider",
        "Selling Cost",
        "Cost to Home-Connect"
      ];
      exportData.forEach((a, index) => {
        excelList.push({
          sno: ++index,
          "Product Name":a.productName,
          "Product Code":a.aliasName,
          "Provider":a.serviceProvider,
          "Selling Cost":a.costValue,
          "Cost to Home-Connect":a.hcCost
        });
      });
      this.excelService.exportAsExcelFile(excelList, "Product_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }
  gotoaddproduct(id) {
    this.navigationService.gotoaddproduct(id);
  }
  deleteProduct (id) {
    Swal.fire({
        title:'You want to deactivate this product?',
        icon:'warning',
        position:'center',
        confirmButtonText:'Yes',
        showConfirmButton:true,
        cancelButtonText:'No',
        confirmButtonColor: '#7D32DE',
        cancelButtonColor: '#23C00A',
        showCancelButton:true
    }).then(res=>{
        if(res.isConfirmed){
            this.ProductService.deleteProduct(id).subscribe( (results)=> {
                this.toastr.showSuccess('Deactivated Successfully');
                this.getTableData('')
            });
        }
    })
}

activateProduct(id){
  Swal.fire({
    title:'You want to activate this product?',
    icon:'warning',
    position:'center',
    confirmButtonText:'Yes',
    showConfirmButton:true,
    cancelButtonText:'No',
    confirmButtonColor: '#7D32DE',
    cancelButtonColor: '#23C00A',
    showCancelButton:true
}).then(res=>{
    if(res.isConfirmed){
        this.ProductService.activateProduct(id).subscribe( (results)=> {
            this.toastr.showSuccess('Activated Successfully');
            this.getTableData('')
        });
    }
})  
}

}


